import { EmoticonCoolOutlineIcon } from './EmoticonCoolOutlineIcon';

/**
 * author: Austin Andrews
 * id 62BB1B4E-67AC-4DFE-B37C-65D0F04F71D0
 * name emoticon-cool-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-cool-outline.svg
 * tags
 * - Emoji 
 */
export const EmojiCoolOutlineIcon = EmoticonCoolOutlineIcon;
export default EmojiCoolOutlineIcon